module.exports = __webpack_public_path__ + "static/media/game-sound-intro.bf848bbc.mp3";